import ColorPickerPopover from "app/components/ColorPicker/ColorPickerPopover";
import { SprintIcon } from "app/components/Icons";
import Input from "app/components/Input";
import { CreateAssetResponse } from "app/components/MediaUploader/types";
import { selectTicketFormDetail } from "app/containers/Features/containers/Boards/containers/Tickets/redux/selector";
import { selectTicketTypes } from "app/redux/selector";
import { IWorkspaceProjects, IWorkspaceTeams } from "app/types";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import Attachments from "./Attachments";
import ContextFields from "./ContextFields";
import CustomFields from "./CustomFields";

const DEFAULT_EPIC_COLOR = "#27AE60";

interface Props {
  sprintName: string;
  selectedTeam: IWorkspaceTeams;
  selectedProject: IWorkspaceProjects;
  createTicketForHome: boolean;
  isAddEpicModal?: boolean;
}
const Index: React.FC<Props> = ({
  sprintName,
  selectedProject,
  selectedTeam,
  createTicketForHome,
  isAddEpicModal = false,
}) => {
  const { project } = useParams<{ project: string }>();
  const dispatch = useDispatch();
  const ticketTypes = useSelector(selectTicketTypes);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);

  const form = useSelector(selectTicketFormDetail);
  const selectedType = ticketTypes.find((t) => t._id === form?.type);
  const showEpicColor =
    isAddEpicModal ||
    selectedType?.icon?.toLowerCase() === "epic" ||
    selectedType?.name?.toLowerCase().includes("epic");
  const epicColor = form?.color || DEFAULT_EPIC_COLOR;

  useEffect(() => {
    if (!showEpicColor || form?.color) return;
    dispatch(
      ticketGroupsActions.setTicketFormValue({
        name: "color",
        value: DEFAULT_EPIC_COLOR,
      }),
    );
  }, [showEpicColor, form?.color, dispatch]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(ticketGroupsActions.setTicketFormValue({ name: name, value: value }));
  };
  const handleChangeFile = (data: CreateAssetResponse) => {
    dispatch(ticketGroupsActions.setTicketAttachments({ data: data }));
  };

  const handleCustomFieldChange = (data) => {
    dispatch(ticketGroupsActions.setTicketFormCustomField(data));
  };

  return (
    <div className=" relative flex flex-col gap-2 ">
      <div className="flex flex-col gap-4 sticky top-0 z-50 bg-white">
        {!createTicketForHome && (
          <div className=" flex inline-flex h-[48px] justify-start items-center text-sm  font-normal px-6 gap-1.5 border-b border-gray-100 ">
            <span className=" text-secondary ">{selectedTeam?.teamName} /</span>
            {selectedProject && (
              <span className="text-success">
                {selectedProject?.projectName}
              </span>
            )}
            {sprintName && (
              <p className=" inline-flex items-center text-secondary ">
                {" "}
                / <SprintIcon color="#253858" size={16} />
                <span className=" text-black font-medium ">{sprintName}</span>
              </p>
            )}
          </div>
        )}

        <Input
          placeholder={isAddEpicModal ? "Enter epic name" : "Enter task name"}
          id="name"
          inputClassName="!h-[27px] border-none !px-0 rounded-none"
          className="!text-lg !leading-[27px] rounded-none placeholder:!text-lg placeholder:!leading-[27px]"
          name="title"
          value={form?.title}
          onChange={handleChange}
          containerClassName={clsx("px-6 ", createTicketForHome && " py-4 ")}
          icon={
            showEpicColor ? (
              <ColorPickerPopover
                trigger={
                  <div
                    className="size-4 rounded-[2px] cursor-pointer"
                    style={{ background: epicColor }}
                  />
                }
                selectedColor={epicColor}
                updateCode={(val) =>
                  dispatch(
                    ticketGroupsActions.setTicketFormValue({
                      name: "color",
                      value: val,
                    }),
                  )
                }
                open={colorPickerOpen}
                setOpen={setColorPickerOpen}
                colorPlateAlign="end"
                className="!w-[255px]"
              />
            ) : null
          }
        />
      </div>
      <div className=" flex flex-col gap-4 px-6 ">
        <ContextFields
          form={form}
          ticketTypes={ticketTypes}
          projectId={project as string}
          createTicketForHome={createTicketForHome}
          selectedTeam={selectedTeam}
          selectedProject={selectedProject}
          isAddEpicModal={showEpicColor}
        />
        <CustomFields
          form={form}
          onChange={handleCustomFieldChange}
          ticketTypes={ticketTypes}
        />
        <Attachments handleChangeFile={handleChangeFile} form={form} />
      </div>
    </div>
  );
};

export default Index;
